import React, { Fragment, useContext, useLayoutEffect, useState,} from "react";
import Loader from "./Loader";
import Taptop from "./TapTop";
import Header from "./Header";
import SideBarLayout from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import CustomizerContext from "../_helper/Customizer";
import ProductContext from "../_helper/Ecommerce/Product";
import GoogleAuthBanner from "../Components/Common/GoogleAuthBanner";

const Layout = () => {
  const { sidebar_types, toggleIcon, setToggleIcon, defaultClass, clickEvent, setDefaultClass, setwidth,} = useContext(CustomizerContext);
  const { setIsVertical } = useContext(ProductContext);
  const sidebar_types1 = localStorage.getItem("sidebar_types") || sidebar_types;
  const [window_Width, setWindow_Width] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  // Single responsive handler.
  //  - Desktop (>=992px): NEVER auto-collapse. Restore the user's saved
  //    sidebar preference so it stays expanded permanently unless they
  //    collapsed it themselves via the header hamburger.
  //  - Mobile (<992px): keep the sidebar hidden off-canvas by default; it
  //    opens as an overlay drawer on demand.
  useLayoutEffect(() => {
    const applyResponsive = () => {
      const w = window.innerWidth;
      setWindow_Width(w);
      setwidth(w);
      setIsVertical(w <= 1215);
      if (w < 992) {
        setToggleIcon(true); // mobile: hidden
      } else {
        setDefaultClass(false);
        setToggleIcon(localStorage.getItem("sidebar_collapsed") === "true");
      }
    };
    applyResponsive();
    window.addEventListener("resize", applyResponsive);
    return () => window.removeEventListener("resize", applyResponsive);
  }, [clickEvent]);

  const closeOverlay = () => {
    setToggleIcon(!toggleIcon);
  };
  return (
    <Fragment>
      <Loader />
      <Taptop />
      <div
        className={`page-wrapper ${
          !defaultClass ? sidebar_types1 : "compact-wrapper"
        }`}
        id="pageWrapper"
      >
        <div className={`page-header ${toggleIcon ? "close_icon" : ""}`}>
          <Header />
        </div>
        <div className="page-body-wrapper">
          <div className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`}>
            <SideBarLayout />
          </div>
          <div className="page-body">
            <GoogleAuthBanner />
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
      <div
        className={`bg-overlay ${
          window_Width < 992 && toggleIcon === false ? "active" : ""
        }`}
        onClick={() => {
          closeOverlay();
        }}
      ></div>
    </Fragment>
  );
};
export default Layout;
